import React from 'react';
import { FaqDropdown } from '../../../components/faq-dropdown';
import { Main } from '../../../layouts/main';
import { Container } from './styles';

const initialState = {
  0: false,
  1: false,
  2: false
};

export const Provider: React.FC = () => {
    
  const [state, setState] = React.useState(initialState);
    
  return (
    <Main>
      <Container>
        <FaqDropdown
          marginTop={1}
          state={state[0]}
          content={'Posso concorrer por fornecimento de cirurgias? '}
          onClick={() => {
            setState((old) => (old = { ...initialState, 0: !old[0] }));
          }}
        >
          Não. Nossa plataforma não interfere na relação do médico com os fornecedores de material. Sendo assim, a empresa 
          entra no fluxo após a indicação do cirurgião.
        </FaqDropdown>
          <FaqDropdown
          marginTop={1}
          state={state[1]}
          content={'Posso negar fornecimento de material?'}
          onClick={() => {
            setState((old) => (old = { ...initialState, 1: !old[1] }));
          }}
        >
          Uma das atribuições do portal do Fornecedor é reportar um erro no fornecimento. Que pode ser por falta do material, 
          incosistência na guia autorizada pelo convênio ou qualquer outro motivo que a empresa ache necessário comunicar 
          ao Cirurgião. O fluxo retornará ao cirurgião para mudança do material solicitado ou do Fornecedor.
        </FaqDropdown>
          <FaqDropdown
          marginTop={1}
          state={state[2]}
          content={'Recebi notificações sobre cirurgias?'}
          onClick={() => {
            setState((old) => (old = { ...initialState, 2: !old[2] }));
          }}
        >
          Sim. Entre inúmeras outras vantagens as notificações são base da nossa Plataforma. Notificações de indicação para 
          procedimento, tempo de vencimento de guia e próximas cirurgias são exemplos de notificações.  
        </FaqDropdown>
      </Container>
    </Main>
  );
}